import React from 'react'

function LoginTitle() {
  return (
    <h1 className="login-title">Entrar</h1>
  )
}

export default LoginTitle